<div class="panel-container">
    <mat-icon svgIcon="flag" />
    <div class="version-title">
        {{ 'version-history.panel.owner.title' | translate: { version: version } }}
    </div>
    <div class="row-container">
        <div>{{ 'version-history.panel.owner.assigned' | translate }}</div>
        <div [ngStyle]="{ color: getStringColor(owner) }">{{ owner }}</div>
    </div>
    <div class="row-container" *ngFor="let editor of editors">
        <div>{{ 'version-history.panel.owner.editor' | translate }}</div>
        <div [ngStyle]="{ color: getStringColor(editor) }">{{ editor }}</div>
    </div>
</div>
